import { types } from "mobx-state-tree";

export const Announce = types
    .model({
        name: types.string,
        description: types.string,
    })
    .named("Announce");

export type AnnounceType = typeof Announce.Type;
